export const questions = [
  {
    id: 1,
    title: "Jan Kochanowski wszechstronnie utalentowany?",
    answer:
      "Malowidła, które z wielkimi trudami udało się odrestaurować przez wybitnych konserwatorów zabytków, są podpisane inicjałami poety. Tutaj również jest wiele pytań, gdyż dzieła przedstawiają niewiasty z odsłoniętymi piersiami. Jedna z kobiet ma brodę.",
  },
  {
    id: 2,
    title: "Czaszce Jana z Czarnolasu nie dano spokoju",
    answer:
      "Wędrowała z rąk do rąk, zmieniając właścicieli. Pierwszy wykopał ją z grobu Tadeusz Czacki (1791) do celów stworzenia muzeum pamiątek. 5 lat później przekazał ją do rąk Izabeli Czartoryskiej. Po upadku powstania listopadowego (1831) czaszka znalazła się we Francji i w roku 1876 wróciła do Polski. Znajduje się ona w Muzeum Zbiorów Czartoryskich w Krakowie. Gdy przedmiotem zajęli się polscy naukowcy, doszli do zaskakującego wniosku: to była najprawdopodobniej czaszka żony Kochanowskiego, Doroty Podolskiej.",
  },
  {
    id: 3,
    title: "Edukacja w Krakowie",
    answer:
      "Podjął studia około roku 1544 na Akademii Krakowskiej, na której edukację zakończył w 1549 roku nie otrzymując żadnego stopnia akademickiego.",
  },
  {
    id: 4,
    title: "Ślub",
    answer:
      "Kochanowski ożenił się z Dorotą Podlodowską z Przytyka. Nie jest znana dokładna data ślubu, który zależnie od źródeł umiejscawia się w roku 1569, 1570, 1574 lub 1577.",
  },
  {
    id: 4,
    title: "Dzieci poety",
    answer:
      "Z Dorotą miał 6 córek, z których trzy zmarły w okresie dzieciństwa. Męski potomek Kochanowskiego urodził się dopiero po jego śmierci.",
  },
];
